define('org/forgerock/openam/ui/user/services/SessionService',["exports", "lodash", "moment", "store/actions/creators", "org/forgerock/commons/ui/common/main/AbstractDelegate", "org/forgerock/commons/ui/common/util/Constants", "store/index", "org/forgerock/openam/ui/user/login/gotoUrl"], function (exports, _lodash, _moment, _creators, _AbstractDelegate, _Constants, _index, _gotoUrl) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.logout = exports.isSessionValid = exports.updateSessionInfo = exports.getTimeLeft = undefined;

    var _lodash2 = _interopRequireDefault(_lodash);

    var _moment2 = _interopRequireDefault(_moment);

    var _AbstractDelegate2 = _interopRequireDefault(_AbstractDelegate);

    var _Constants2 = _interopRequireDefault(_Constants);

    var _index2 = _interopRequireDefault(_index);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var obj = new _AbstractDelegate2.default(_Constants2.default.host + "/" + _Constants2.default.context + "/json/sessions"); /*
                                                                                                                                * Copyright 2014-2017 ForgeRock AS. All Rights Reserved
                                                                                                                                *
                                                                                                                                * Use of this code requires a commercial software license with ForgeRock AS.
                                                                                                                                * or with one of its affiliates. All use shall be exclusively subject
                                                                                                                                * to such license between the licensee and ForgeRock AS.
                                                                                                                                */

    var getSessionInfo = function getSessionInfo(options) {
        return obj.serviceCall(_lodash2.default.merge({
            url: "?_action=getSessionInfo",
            type: "POST",
            data: {},
            headers: {
                "Accept-API-Version": "protocol=1.0,resource=2.0"
            }
        }, options));
    };

    var getTimeLeft = exports.getTimeLeft = function getTimeLeft(token) {
        return getSessionInfo(token, { suppressSpinner: true }).then(function (sessionInfo) {
            var idleExpiration = (0, _moment2.default)(sessionInfo.maxIdleExpirationTime).diff((0, _moment2.default)(), "seconds");
            var maxExpiration = (0, _moment2.default)(sessionInfo.maxSessionExpirationTime).diff((0, _moment2.default)(), "seconds");
            return _lodash2.default.min([idleExpiration, maxExpiration]);
        });
    };

    var updateSessionInfo = exports.updateSessionInfo = function updateSessionInfo() {
        var options = { errorsHandlers: { "Unauthorized": { status: 401 } } };

        return getSessionInfo(options).then(function (response) {
            _index2.default.dispatch((0, _creators.sessionAddInfo)({
                realm: response.realm,
                sessionHandle: response.sessionHandle
            }));
            return response;
        });
    };

    var isSessionValid = exports.isSessionValid = function isSessionValid() {
        return getSessionInfo();
    };

    var logout = exports.logout = function logout() {
        var paramString = (0, _gotoUrl.exists)() ? "&goto=" + (0, _gotoUrl.get)() : "";
        return obj.serviceCall({
            url: "?_action=logout" + paramString,
            type: "POST",
            data: {},
            headers: {
                "Accept-API-Version": "protocol=1.0,resource=2.0"
            },
            errorsHandlers: {
                "Bad Request": { status: 400 },
                "Unauthorized": { status: 401 }
            }
        });
    };
});

